import React from 'react'
import NewsLetter from './newsletter'

export default function NewsLetterPage() {
    return (
        <section className='pr-4'>
            <NewsLetter />
        </section>
    )
}
